// src/App.js
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './assets/styles/main.css';
import Calendly from "./components/Calendly";

function App() {
  return (
      <div className="app">
        <Header />
        <main>
          <Hero />
          <Services />
          <Gallery />
          <About />
          <Testimonials />
          <Contact />
          <Calendly />
        </main>
        <Footer />
      </div>
  );
}

export default App;